import ImgLogoPerson from "../assets/svg/icon-logo-person.svg";
import {apiAddUsers, apiGetUser, apiUpdateUser} from "../api/userApi";
import UserAddedInfo from "components/User/UserAddedInfo";
import {updateForm} from "store/actions/formAction";

export const userFormData = {
    key: "user",
    title: "کاربر",
    addFunction: apiAddUsers,
    getFunction: apiGetUser,
    updateFunction: apiUpdateUser,
    navigation: {
        title: "افزودن کاربر جدید",
        description: "ثبت اطلاعات کاربر",
        backTitle: "بازگشت",
        backUrl: "/settings",
    },
    summaryInfo: {
        key: "user",
        primaryTitleKey: "ePhone",
        addTempTitle: "افزودن کاربر جدید",
        saveTitle: "ذخیره کاربران",
        editTitle: "به روز رسانی کاربر",
        defaultImage: ImgLogoPerson,
    },
    AddedInfo: UserAddedInfo,
    tabs: [
        {
            key: "user",
            name: "کاربر",
            form: {
                main: {
                    wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                    imagePicker: {
                        active: false,
                    },
                    inputs: [
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
                            name: "ePhone",
                            label: "تلفن همراه",
                            required: true,
                            maxLength: 32,
                            primary: true,
                        },
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
                            name: "roleId",
                            label: "نوع کاربر",
                            type: "selectBox",
                            options: "roles",
                            onChange: (dispatch, value, permissions) => {
                                permissions.map((item) => {
                                    dispatch(updateForm(item.id, false));
                                });
                                value.Accesses.map((item) => {
                                    dispatch(updateForm(item.id, true));
                                });
                            },
                        },
                    ],
                },
            },
        },
    ],
};
